import ProductSummaryImageProvider from './hooks/useProductSummaryImage';

import { ProductSummaryImageProps } from './@types/ProductSummaryImageProps';
import ProductSummaryImageContainer from './handles/ProductSummaryImageContainer';
import CollectionContainer from './handles/CollectionContainer';
import DiscountContainer from './handles/DiscountContainer';
import DiscountInsideContainer from './handles/DiscountInsideContainer';
import Image from './handles/Image';

const ProductSummaryImage = (props: ProductSummaryImageProps) => {
	const renderContainer = () => {
		if (props.showCollections) {
			return (
				<CollectionContainer>
					{props.showBadge ? (
						<DiscountContainer>
							<DiscountInsideContainer />
							<Image />
						</DiscountContainer>
					) : (
						<>
							<Image />
						</>
					)}
				</CollectionContainer>
			);
		}

		if (props.showBadge) {
			return (
				<DiscountContainer>
					<DiscountInsideContainer />
					<Image />
				</DiscountContainer>
			);
		}

		return (
			<>
				<Image />
			</>
		);
	};

	return (
		<ProductSummaryImageProvider {...props}>
			<ProductSummaryImageContainer>{renderContainer()}</ProductSummaryImageContainer>
		</ProductSummaryImageProvider>
	);
};

export default ProductSummaryImage;
